<template>
  <div class="insights-meetings-widget-dialog-ranking">
    <div class="title">Top apps & URLs used during meetings</div>
    <ul
      v-if="hasData"
      class="list-unstyled mb-0"
    >
      <li
        v-for="tool in meetings.ranking"
        :key="tool.id"
        class="tool d-flex align-items-center"
      >
        <i
          :class="itemIconClass(tool)"
          class="type-icon"
        />
        {{ tool.tool_name }}
      </li>
    </ul>
    <div v-else>No data available.</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'InsightsMeetingsDialogRanking',
  computed: {
    ...mapGetters(['meetings']),
    hasData() {
      return this.meetings.ranking?.length;
    },
  },
  methods: {
    itemIconClass(item) {
      const icon = item.tool_type === 'url' ? 'fa fa-globe' : 'fa fa-laptop';

      return `text-muted ${icon} mr-10`;
    },
  },
};
</script>
